// extracted by mini-css-extract-plugin
export default {"howDoTraders":"HowToOpen_howDoTraders__7ay9i","title":"HowToOpen_title__MO5kg","content":"HowToOpen_content__3wsd-","text":"HowToOpen_text__kbtfT"};